import React, { useEffect } from 'react';
import { Icon } from '../Icon';
import { Icons } from '@/assets';
import { noScroll, removeNoScroll } from '@/actions/Helper';

const LoadingV2 = ({ isFullscreen = false }) => {
  useEffect(() => {
    if (isFullscreen) noScroll();
    return () => {
      if (isFullscreen) removeNoScroll();
    };
  }, [isFullscreen]);

  return isFullscreen ? (
    <div className=" flex-col  fixed inset-0 z-loading bg-loading-overlay backdrop-blur-6 flex items-center justify-center">
      <Icon src={Icons.loadingIndicator} width="100px" />
      <p className="text-light-bg text-xl m-0 mt-6">Loading, please wait…</p>
    </div>
  ) : (
    <div className="flex flex-1 flex-col items-center justify-center w-full h-full min-h-full z-loading">
      <Icon src={Icons.loadingIndicatorGray} width="84px" />
      <p className="text-inactive-text text-xl m-0 mt-6">
        Loading, please wait…
      </p>
    </div>
  );
};

export default LoadingV2;
